// import {
//   fetch_user_list as fetch_user_client_list
// } from '@/api/communication'
import {
  fetchUserClint
} from '@/api/blog-post.js'
export const  UserMixins = {
  data () {
    return {
      query_page_user: {
        page: 1
      },
      query_page_client: {
        page: 1
      },
      userList:[],
      clientList:[]
    }
  },
  methods:{
    async loadMoreUser ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        try {
          const res = await fetchUserClint(
            localStorage.getItem('customer_id'),
            'User',
            {page:this.userListMeta.current_page + 1}
          )
          const tempUser = res.data.data.users_list.map(ele => {
            return {
              fullName:`${ele.first_name} ${ele.last_name}`,
              user_id: ele.users_id,
              user_type: 1
            }
          })
          this.userList.push(...tempUser)
          
          this.userListMeta = res.data.data.meta

        } catch (e) {
          console.log(e)
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpenUser () {
      if (this.userListMeta.has_next) {
        await this.$nextTick()
        this.observerUser.observe(this.$refs.load)
      }
    },
    onCloseUser () {
      this.observerUser.disconnect()
    },
    async loadMoreClient ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        try {
          const res = await fetchUserClint(
            localStorage.getItem('customer_id'),
            'Client',
            {page:this.clientListMeta.current_page + 1}
          )
          const tempUser = res.data.data.users_list.map(ele => {
            return {
              fullName:`${ele.first_name} ${ele.last_name}`,
              client_user_id: ele.client_users_id,
              user_type: 2
            }
          })
       
          this.clientList.push(...tempUser)
          this.clientListMeta = res.data.data.meta

        } catch (e) {
          console.log(e)
        }

        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpen () {
      if (this.clientListMeta.has_next) {
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onClose () {
      this.observerStudent.disconnect()
    },
    async fetch_user_client_list (type) {

      try {
        this.$vs.loading()
        //  const data = await fetch_user_client_list(customer_id, type)
        //
        if (type === 'User') {
          const data = await fetchUserClint(
            localStorage.getItem('customer_id'), type,
            this.query_page_user
          )
          this.userList = data.data.data.users_list
          this.userList = this.userList.map(ele => {
            return {
              fullName:`${ele.first_name} ${ele.last_name}`,
              user_id: ele.users_id,
              user_type: 1
            }
          })
          this.userListMeta = data.data.data.meta
        } else if (type === 'Client') {
          const data = await fetchUserClint(
            localStorage.getItem('customer_id'), type,
            this.query_page_client
          )
          this.clientList = data.data.data.users_list
          this.clientList = this.clientList.map(ele => {
            return {
              fullName:`${ele.first_name} ${ele.last_name}`,
              client_user_id: ele.client_users_id,
              user_type: 2
            }
          })
          this.clientListMeta = data.data.data.meta
        }

        return true

      } catch (error) {
        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    
    async loadUserClientList (type, meta) {

      try {
        // this.$vs.loading()
        //  const data = await fetch_user_client_list(customer_id, type)
        //
        if (type === 'User') {
          const data = await fetchUserClint(
            localStorage.getItem('customer_id'), type,
            {
              page: meta.current_page
            }
          )  
          const tempClientUser = data.data.data.users_list.map(ele => {
            return {
              first_name: ele.first_name,
              last_name: ele.last_name,
              user_id: ele.users_id,
              user_type: 1,
              picture: ele.picture
            }
          })
          this.userList.push(...tempClientUser)
          this.userListMeta = data.data.data.meta
        } else if (type === 'Client') {
          const data = await fetchUserClint(
            localStorage.getItem('customer_id'), type,
            {
              page: meta.current_page
            }
          )    
          const tempUser = data.data.data.users_list.map(ele => {
            return {
              first_name: ele.first_name,
              last_name: ele.last_name,
              client_user_id: ele.client_users_id,
              user_type: 2,
              picture: ele.picture
            }
          })
          this.clientList.push(...tempUser)
          this.clientListMeta = data.data.data.meta
        }

        return true

      } catch (error) {
        console.log(error)
      } finally {
        // this.$vs.loading.close()
      }
    }
  }
}
